import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import useTermsAcceptance from '../../hooks/useTermsAcceptance';
import TermsAcceptanceModal from '../common/TermsAcceptanceModal';

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();

  // Only clients need to re-accept T&C on version change — admin/staff
  // aren't subject to the customer agreement, and locking them out would
  // block the very Terms Management view they need to publish the new
  // version. Check runs after auth resolves.
  const isCustomer =
    !!user && !['admin', 'super_admin', 'staff'].includes(user.role);
  const termsStatus = useTermsAcceptance(isCustomer);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#F97316]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" />;
  }

  if (requireAdmin && !['admin', 'super_admin', 'staff'].includes(user.role)) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <>
      {children}
      {isCustomer && !termsStatus.loading && termsStatus.needsAcceptance && (
        <TermsAcceptanceModal
          isOpen={true}
          canClose={false}
          forceAccept={true}
          onAccept={() => termsStatus.markAccepted()}
        />
      )}
    </>
  );
};

export default ProtectedRoute;
